let __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
import computeTourSteps from '../core/steps'
import { updateDialogHtml } from '../core/dialog'
import waitForElm from '../util/util_wait_for_element'
/**
 * handleAddStep
 * @param newSteps
 */
function handleAddStep(newSteps) {
  return __awaiter(this, void 0, void 0, function*() {
    // TS build strict check
    if (!this.options.steps) return
    // Add step
    this.options.steps.push(...newSteps)
    // recompute tour steps
    yield computeTourSteps(this)
    // update dialog HTML (reflect new steps in dots)
    if (this.isVisible)
      yield updateDialogHtml(this).catch(e => {
        if (this.options.debug) console.warn(e)
      })
    // recompute dialog & backdrop positioning
    if (this.isVisible)
      this.updatePositions().catch(e => {
        if (this.options.debug) console.warn(e)
      })
    /**
     * If dialog is rendered in DOM
     */
    if (this.isVisible)
      yield waitForElm('.tg-dialog').then(() =>
        __awaiter(this, void 0, void 0, function*() {
          /**
           * Init listeners
           * Double initialization is handled inside of handler
           */
          yield this.destroyListeners()
          yield this.initListeners()
          // Add transition class to dialog after additional delay to prevent flying in from random position
          // if (this.options.dialogAnimate) setTimeout(() => {
          //     this.dialog.classList.add('animate-position')
          // }, 600)
          return true
        })
      )
  })
}
export default handleAddStep
